import shareableLinks from './shareable-links';
import shareableLinksDocuments from './shareable-links-documents';
import websocket from './websocket';

export default {
  shareableLinks,
  shareableLinksDocuments,
  websocket,
};
